//styles
import * as S from './RefundTimelineBar.styles';

const RefundTimelineBar = ({customClass, timeline}: {customClass?: string; timeline: []}) => {
  if (!timeline || !timeline?.length) return null;
  return (
    <S.RefundTimelineBarWrapper>
      <div className={`rfnd ${customClass ? customClass : ''}`}>
        <div className="rfnd__topBarCont" data-testid="rfnd__topBarCont">
          <span className="rfnd__topBar--oval rfnd__topBar--ovalLeft" />
          <span className="rfnd__topBar--oval rfnd__topBar--ovalRight" />
          <span className="rfnd__bottomText--now">Now</span>
          <div className="rfnd__topBar">
            {timeline.map((item, index) => (
              <div
                className={`rfnd__topBar--col ${item?.refundable ? 'green' : 'yellow'}`}
                key={index}
              >
                {item?.text && (
                  <span
                    className={`font10 latoBold ${
                      item?.refundable ? 'whiteText' : 'lightYellowText'
                    }`}
                    dangerouslySetInnerHTML={{__html: item?.text}}
                  />
                )}
                <div className="rfnd__bottomText">
                  {item?.endDate && (
                    <span className="rfnd__bottomText--title">{item?.endDate}</span>
                  )}
                  {item?.endDateTime && (
                    <span className="rfnd__bottomText--title">{item?.endDateTime}</span>
                  )}
                  {index === timeline.length - 1 && (
                    <span className="rfnd__bottomText--subTitle">Check-in</span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </S.RefundTimelineBarWrapper>
  );
};
export default RefundTimelineBar;
